import { MolsonBox, MolsonButton, MolsonTypography } from '@components/reusable'
import { molsonUseTheme } from '@theme/customMuiExports'
import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

type NeedsRevisingItemWrapperProps = {
  content: string
  displayButtons?: boolean
  displayShowButton?: boolean
  divider?: ReactNode
  handleRemove: () => void
  handleShow?: () => void
  title: string
  disabled?: boolean
  translationPrefix: string
}

export const NeedsRevisingItemWrapper = ({
  content,
  displayButtons = true,
  displayShowButton = true,
  divider,
  handleRemove,
  handleShow,
  title,
  disabled = false,
  translationPrefix
}: NeedsRevisingItemWrapperProps) => {
  const theme = molsonUseTheme()
  const { t } = useTranslation('', {
    keyPrefix: translationPrefix
  })
  return (
    <MolsonBox display="flex" flexDirection="column">
      <MolsonBox
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <MolsonBox
          display="flex"
          flexDirection="column"
          maxWidth={displayButtons ? 'calc(100% - 165px)' : '100%'}
        >
          <MolsonTypography fontSize={12} variant="body2">
            {title}
          </MolsonTypography>
          <MolsonTypography
            color={theme.palette.primary.error}
            fontWeight={700}
            noWrap={true}
            sx={{ textDecoration: 'line-through' }}
            variant="body2"
          >
            {content}
          </MolsonTypography>
        </MolsonBox>
        {displayButtons ? (
          <MolsonBox alignSelf="center" display="flex" gap={1} height={32}>
            {displayShowButton && (
              <MolsonButton
                disabled={disabled}
                color="secondary"
                onClick={handleShow}
                sx={{ borderRadius: 2, fontSize: 12 }}
                variant="outlined"
              >
                {t('show')}
              </MolsonButton>
            )}
            <MolsonButton
              disabled={disabled}
              color="error"
              onClick={handleRemove}
              sx={{ borderRadius: 2, fontSize: 12 }}
              variant="contained"
            >
              {t('remove')}
            </MolsonButton>
          </MolsonBox>
        ) : null}
      </MolsonBox>
      {divider}
    </MolsonBox>
  )
}
